/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_Recovery_StrongInputs */

const en_ui_stat_recovery_strong = /** @type {(inputs: Ui_Stat_Recovery_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong recovery`)
};

const de_ui_stat_recovery_strong = /** @type {(inputs: Ui_Stat_Recovery_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starke Erholung`)
};

/**
* | output |
* | --- |
* | "Strong recovery" |
*
* @param {Ui_Stat_Recovery_StrongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_recovery_strong = /** @type {((inputs?: Ui_Stat_Recovery_StrongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_Recovery_StrongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_recovery_strong(inputs)
	return de_ui_stat_recovery_strong(inputs)
});